import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FieldRichText, FormField, FormGrid, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { connect } from 'react-redux';
import { Field, Form, formValueSelector, reduxForm, } from 'redux-form';
import { v4 as uuid } from 'uuid';
import { SanitizeHTML } from 'app/utils/htmlSanitizer';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { getAvailableFlowVariables, } from 'components/powerFlowShared/helpers/flowVariableHelpers';
import { getConfirmButtonVerb } from 'components/powerFlowShared/helpers/getConfirmButtonVerb';
import { useElevioIntegration } from '../../../../elevioIntegrationProvider';
import { useParsedHtmlTextContent } from '../../../../hooks/useParsedHtmlTextContent';
import { useElevioArticleQuickResponse } from '../../../shared/knowledgeBaseLinkPreview/hooks/useElevioRichTextInputQuickResponse';
import { extractRichTextContentWithHtmlTags } from '../../../shared/utils/extractRichTextContentWithHtmlTags';
import { FlowVariableSelector } from '../variableSelector';
import { MessengerMessagePreview } from './components/messengerMessagePreview';
import { formatVariablesForTextInput } from './formatVariablesForTextInput';
import styles from './messageModal.module.scss';
const validate = (values) => {
    const errors = {};
    if (!values) {
        return errors;
    }
    if (!values.text) {
        errors.text = 'Message is required';
    }
    return errors;
};
const MessageModalImpl = (props) => {
    var _a;
    const { flowType, scopeVars, handleSubmit, node, nodeLabel, replaceNode, triggerClose, destroy, text, dirty: isChanged, } = props;
    const { elevioIntegration } = useElevioIntegration();
    const hasElevioIntegration = Boolean(elevioIntegration === null || elevioIntegration === void 0 ? void 0 : elevioIntegration.companyId);
    const availableFlowVariables = getAvailableFlowVariables({
        flowType,
        scopeVars,
    });
    const handleSaveClick = useCallback((values) => {
        var _a;
        const nodeOptions = Object.assign(Object.assign({}, node), { badges: [], childIds: [], icon: '', isAction: false, isEditable: true, isRemovable: true, nodeType: FlowNodeTypes.MESSENGER_MESSAGE, overlay: [], payload: {
                text: values.text,
                nextNodeId: ((_a = node.payload) === null || _a === void 0 ? void 0 : _a.nextNodeId) || uuid(),
            }, text: '' });
        replaceNode(nodeOptions);
        triggerClose();
    }, [node, replaceNode, triggerClose]);
    const closeModal = useCallback(() => {
        destroy();
        triggerClose();
    }, [destroy, triggerClose]);
    const { quickResponseApi, quickResponseRenderer } = useElevioArticleQuickResponse({
        search: useParsedHtmlTextContent(text),
    });
    return (_jsxs(Box, Object.assign({ width: "800px" }, { children: [_jsx(ModalHead, Object.assign({ title: nodeLabel, onClose: closeModal }, { children: "This action allows you to send automated replies to customers following any action." })), _jsxs(Form, Object.assign({ onSubmit: handleSubmit(handleSaveClick) }, { children: [_jsx(ModalBody, { children: _jsxs(FormGrid, Object.assign({ className: styles.formGrid }, { children: [_jsx(FormField, Object.assign({ span: 3 }, { children: _jsx(Field, { component: FieldRichText, name: "text", label: "Your message", mode: "textarea", className: styles.editor, inputClassName: styles.editorInput, toolbarAddons: _jsx(FlowVariableSelector, { variables: formatVariablesForTextInput(availableFlowVariables) }), quickResponseIcon: "elevio", quickResponsesApi: hasElevioIntegration ? quickResponseApi : undefined, renderQuickResponse: hasElevioIntegration ? quickResponseRenderer : undefined, sanitize: SanitizeHTML.sanitizerForChannel('messenger'), languages: (_a = elevioIntegration === null || elevioIntegration === void 0 ? void 0 : elevioIntegration.availableLocales) !== null && _a !== void 0 ? _a : [], editorContentExtractor: extractRichTextContentWithHtmlTags }) })), _jsx(FormField, Object.assign({ span: 3 }, { children: _jsx(MessengerMessagePreview, { variables: availableFlowVariables, text: text }) }))] })) }), _jsx(ModalFoot, { confirmOnClick: handleSubmit(handleSaveClick), confirmName: getConfirmButtonVerb(node), confirmProps: { disabled: !isChanged }, cancelOnClick: closeModal })] }))] })));
};
const formName = 'messengerMessageModal';
const mapStateToProps = (state, ownProps) => {
    const { payload } = ownProps.node;
    const selector = formValueSelector(formName);
    return {
        initialValues: {
            text: (payload === null || payload === void 0 ? void 0 : payload.text) || '',
        },
        text: selector(state, 'text'),
    };
};
export const MessageModal = connect(mapStateToProps)(reduxForm({
    enableReinitialize: true,
    form: formName,
    touchOnBlur: false,
    validate,
})(MessageModalImpl));
